import AppHeader from '../AppHeader'

export default {
  name: 'question-new',
  data () {
    return {
      title: '',
      questions: [
        {content: '', displayOrder: 1}
      ],
      canValidate: true,
      savingFlag: false
    }
  },
  computed: {
    validation: function () {
      var v = {
        title: !!this.title,

        not_input: !!this.title
      }
      v.content = []
      v.content_all = true
      for (let index in this.questions) {
        let vc = !!(this.questions[index].content)
        v.content.push(vc)
        v.content_all &= vc
      }
      v.not_input = v.not_input && !!v.content.length && !!v.content_all

      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      if (this.savingFlag) return false
      this.savingFlag = true
      this.$store.dispatch('QUESTION_CREATE', {
        data: {
          title: this.title,
          contents: this.questions
        }
      })
      .then(res => {
        this.$router.push({path: '/question'})
      })
      .catch(err => console.log(err))
    },
    onClickCancel: function () {
      this.$router.push('/question')
    },
    addContent: function (index) {
      let question = {content: null, displayOrder: index + 2}
      this.questions.splice(index + 1, 0, question)
    },
    deleteContent: function (index) {
      this.questions.splice(index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/question-new.js